import React, { useContext } from 'react';
//import { jsPDF } from "jspdf";
import 'jspdf-autotable';


import Header from '../../layout/Header';
import proyectoContext from '../../../context/proyectos/proyectoContext';



const Baterias = () => {

    // extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;
    
    // Array destructuring para extraer el proy actual
    const [proyectoActual] = proyecto;

    return (  
        <div>
        <Header />
            <h2 className="mt-3">Calcular las Baterías</h2>
            <h2>Proyecto: {proyectoActual.nombre}</h2>
            <p>Herramienta Altualmente en Construcción</p>
        </div>
    );
}
 
export default Baterias;